import { render, staticRenderFns } from "./OracleInvoice.vue?vue&type=template&id=fdb97030&"
import script from "./OracleInvoice.vue?vue&type=script&lang=js&"
export * from "./OracleInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports